/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Newsletter_Unsubscribe_Done_DescriptionInputs */

const en_newsletter_unsubscribe_done_description = /** @type {(inputs: Newsletter_Unsubscribe_Done_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} won't receive the newsletter anymore.`)
};

/**
* | output |
* | --- |
* | "{email} won't receive the newsletter anymore." |
*
* @param {Newsletter_Unsubscribe_Done_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_unsubscribe_done_description = /** @type {((inputs: Newsletter_Unsubscribe_Done_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Unsubscribe_Done_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_unsubscribe_done_description(inputs)
});